import React, { useEffect, useState } from 'react';
import { analyticsUserTrack } from '../config/analyticsTrack';
import Logo from './assets/logo.png'
import TeqitCoreValuesExplained from './assets/TeqitCoreValuesExplained.png'
import Config from '../helper/Config';
import { Link } from 'react-router-dom';
import bg from './assets/WhatWeDoBgv3.png'
import "./Custom.css"
import Footer from './Footer';
import Header from './components/Header';


export default function OurTeam(props) {
    const [showMenu, setShowMenu] = useState(false);


    useEffect(() => {
        analyticsUserTrack("Home", "Our Team");
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const shouldShow = scrollTop > 150;

            setShowMenu((prev) => {
                if (prev !== shouldShow) {
                    return shouldShow;
                }
                return prev;
            });
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);

    }, [])

    return <div className='may-2025 what-we-do'>
        <div className='block1' style={{ marginTop: 0 }}>
            <div className={`home-sticky-crop home ${showMenu ? "home-sticky-background" : ""}`} style={{ top: 0 }}>
                <Link to={Config.projectUrl + "/"} onClick={() => window.scrollTo(0, 0)}>
                    <img className='logo' src={Logo} />
                </Link>
                {
                    showMenu && <Header />
                }
            </div>
        </div>
        <div className="full-screen-image">
            <div className="bg-image d-flex align-items-center justify-content-center">
                <img className='img-fluid' src={bg} alt="Teqbahn-How-we-do" style={{ maxHeight: "100%" }} />
            </div>
            <div className='bg-text montserrat-font-family'>
                Teqbahn is building intelligent innovation for meaningful connectivity
            </div>
        </div>
        <div className='block1'>
            <div className='container py-5'>
                <div className='row'>
                    <div className='px-2 col-sm-4 d-flex flex-column justify-content-center'>
                        <div className='col '>
                            <div className='title montserrat-font-family my-3'>Agentic by Design</div>
                            <div className='sub-text my-3'>Architected for autonomous and semi-autonomous systems that act, adapt, and collaborate.</div>
                        </div>
                    </div>
                    <div className='px-2 col-sm-4 d-flex flex-column justify-content-center'>
                        <div className='col '>
                            <div className='title montserrat-font-family my-3'>Carbon Sensitive</div>
                            <div className='sub-text my-3'>Optimized for energy efficiency with MicroCloud deployments across rural, urban, and hybrid environments.</div>
                        </div>
                    </div>
                    <div className='px-2 col-sm-4 d-flex flex-column justify-content-center'>
                        <div className='col '>
                            <div className='title montserrat-font-family my-3'>Rightsized</div>
                            <div className='sub-text my-3'>Built to work where infrastructure doesn't - from full-stack apps to SMS-based communication.</div>
                        </div>
                    </div>
                </div>
                <div className='text-center'>
                    <img className='img-fluid' src={TeqitCoreValuesExplained} alt='Teqit' style={{ maxHeight: "calc(100vh - 150px)" }} />
                </div>
            </div>
        </div>
        <Footer />
    </div>;
}
